import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from "../../CommonUI/Pagination/Pagination";
import { Portal } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner';
let companyInformation;

function Basisofallotment() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [dataLoose, setDataLoose] = useState([]);
    const [dataIndex, setDataIndex] = useState([]);
    const [dataNews, setDataNews] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataActive, setDataActive] = useState([]);
    const [dataCap, setDataCap] = useState([]);
    const [dataTicker, setDataTicker] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const [dataDraft2, setDataDraft2] = useState([]);
    const [groupValue, setGroupValue] = useState("sno");
    const [dataBest, setDataBest] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    const [dataIpo, setDataIpo] = useState([]);
    const [dataWatch, setDataWatch] = useState([]);
    const [dataOpen, setDataOpen] = useState([]);
    const [dataClose, setDataClose] = useState([]);
    const [dataBasis, setDataBasis] = useState([]);
    const [dataIssue, setDataIssue] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [dataPer, setDataPer] = useState([]);
    const [fetchIdNews, setFetchIdNews] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [dataaa, setDataaa] = useState([]);
    const [Snonumber, setSnonumber] = useState();
    // const [groupValue, setValueBtn] = useState("sebi");
    const [loadingshow, setloadingshow] = useState(false);
    const [type, settype] = useState(['sebi']);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let getData, getDataLoose, getDataIndex, getDataTicker, fetchId,
        getDataActive, getDataNews, getDataCap, getDataBest, getDataDraft, getDataDraft2, getDataNew, getDataIpo, getDataWatch, getDataOpen, getDataClose, getDataBasis, getDataIssue, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;


    useEffect(() => {
        setloadingshow(true);
        const getUrlBasis = BaseURL + "BasisofAllotment";
        fetch(`${getUrlBasis}/8`)
            .then((response) => response.json())
            .then((dataS) => {
                getDataBasis = dataS.data;
                setDataBasis(getDataBasis);
                //console.log(getDataBasis, "getDataBasis")
                setloadingshow(false);
            })
            .catch((error) => {
            });
    }, []);

    const moreContent = () => {
        navigate("/IPO/Basis-Of-Allotment")
    }

    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>Basis of Allotment</h4>
                    <span className="moreContent" onClick={moreContent} tabIndex={0} >See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className='ipo-common mf-common'>
                        <div className='mf-table table-responsive gainer-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-left'>Company Name</th>
                                        <th className='text-left'>Issue Type</th>
                                        <th className='text-right'>Closed Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(dataBasis === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    {(dataBasis != null) && dataBasis.map(
                                        ({ lname, IssueType, ClosDate }) => (
                                            <tr>
                                                <td className="text-left">{lname} </td>
                                                <td className="text-left">{IssueType} </td>
                                                <td className="text-right"> {(ClosDate != null) ? ClosDate.split('T')[0] : 0}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }

                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}

export default Basisofallotment;